import React from 'react';
import PropTypes from 'prop-types';
import MessageItem from './MessageItem';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as messagesActions from '../shared/actions/messagesActions';
import { I18nUtils } from '../../../../../i18n/I18nUtils';

class Message extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            responseMessage: '',
        };
    }

    onSubmitResponse = (event) => {
        event.preventDefault();
        if ( this.state.responseMessage && this.state.responseMessage.length > 0 ) {
            this.props.messagesActions.responseMessage(
                null,
                this.state.responseMessage,
                this.props.message.id(), // parentMessageId
                () => {this.setState({ responseMessage: '' });},
            );
        }
    }

    renderDivider() {
        if ( this.props.showDivider ) {
            return <hr></hr>;
        }
        return null;
    }

    renderFormResponse() {
        if ( this.props.canResponse ) {
            return (
                <form onSubmit={this.onSubmitResponse}>
                    <div className="row clearfix">
                        <div className="form-group">
                            <div className="col-xs-9">
                                <div className="form-line">
                  <textarea
                      rows="2"
                      id="reply"
                      className="form-control"
                      value={this.state.responseMessage}
                      onChange={(event) => this.setState({ responseMessage: event.target.value })}
                  > </textarea>
                                </div>
                            </div>

                            <div className="col-xs-3">
                                <button
                                    type="submit"
                                    className="btn btn-default btn-sm waves-effect"
                                    disabled={!this.state.responseMessage || this.state.responseMessage.length === 0}
                                >{I18nUtils.tr('TR_ENVIAR')}</button>
                            </div>
                        </div>
                    </div>
                </form>
            );
        }
        return null;
    }

    renderReplyMessages() {
        const { message, authUser } = this.props;

        return message.replyMessages().map((msg) => {
            return (
                <MessageItem
                    key={msg.id()}
                    message={msg}
                    currentUser={authUser && msg.user() && authUser.id === msg.user().id()}
                    canArchive={false}
                    user={authUser}
                />
            );
        });
    }

    render() {
        const { message, authUser, canArchive } = this.props;

        return (
            <div>
                <MessageItem
                    key={message.id()}
                    message={message}
                    currentUser={authUser && message.user() && authUser.id === message.user().id()}
                    canArchive={canArchive}
                    archive={(messageId) => this.props.messagesActions.archiveMessage(messageId)}
                    user={authUser}
                />
                {this.renderReplyMessages()}
                {this.renderFormResponse()}
                {this.renderDivider()}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return ( {
        authUser: state.auth.user,
    } );
};

const mapDispatchToProps = dispatch => ( {
    messagesActions: bindActionCreators(messagesActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(Message);

Message.propTypes = {
    message: PropTypes.objectOf(PropTypes.any).isRequired,
    canResponse: PropTypes.bool.isRequired,
    canArchive: PropTypes.bool.isRequired,
    showDivider: PropTypes.bool.isRequired,
};

Message.defaultValues = {
    canResponse: true,
    canArchive: true,
    showDivider: false,
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/detail/Message.js